export { NumberInput } from './number-input';
export type { NumberInputProps } from './number-input';
